import {RequestAxios} from "../../index";
import {TrainerById} from "./interfaces";
import {API_START} from "../../constants";

export const getTrainerById = async (id: number) => {
    const trainersIdUrl = `${API_START}/trainers/${id}`;
    return await RequestAxios.get<TrainerById>(trainersIdUrl)
}